import React, { ReactNode, createContext, useEffect, useState } from 'react';

const TabContext = createContext<boolean>(true);
export default TabContext;
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition, @typescript-eslint/no-explicit-any
export const TabContextProvider: any = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [isTabbing, updateIsTabbing] = useState(true);
  useEffect(() => {
    const keyUpHandler = ({ which }: { which: number }) => {
      if (which === 9 || which === 13) {
        updateIsTabbing(true);
      }
    };

    const clickHandler = () => {
      // @TODO Remove this hack... can we set isTabbing to `false`
      // by default instead?
      if (window.location.pathname !== '/get-job-alerts') {
        updateIsTabbing(false);
      }
    };

    window.addEventListener('keyup', keyUpHandler);
    window.addEventListener('mousedown', clickHandler);
  }, []);
  return (
    <TabContext.Provider value={isTabbing}>{children}</TabContext.Provider>
  );
};
